// extracted by mini-css-extract-plugin
export default {"background":"ChatBoxStyle_background__WNhlj","textArea":"ChatBoxStyle_textArea__CNDIO","button":"ChatBoxStyle_button__iASbw"};